export default __webpack_public_path__ + "static/media/cloud2.7df59beb.webp";